import React from 'react';
import styles from './WelcomePage.scss';
import { Text, TextButton } from '@wix/design-system';
import { Trans } from '@wix/wix-i18n-config';

export const OneTapDisclaimer = props => {
  const {
    onTermOfUseClicked,
    onPrivacyClicked } = props;

  return (
    <div className={styles.oneTapDisclaimer}>
      <Text size="tiny">
        <Trans
          i18nKey={`WELCOME_PAGE_ONE_TAP_DISCLAIMER`}
          components={{
            linkTerms: (
              <TextButton
                skin="dark"
                underline="always"
                size="tiny"
                onClick={onTermOfUseClicked}
              />
            ),
            linkPrivacy: (
              <TextButton
                skin="dark"
                underline="always"
                size="tiny"
                onClick={onPrivacyClicked}
              />
            )
          }}
        />
      </Text>
    </div>
  );
};
